module.exports = __webpack_public_path__ + "img/aboutApp6.6202b972.png";